import { Injectable } from '@angular/core';
import { LoadingService } from './loading.service';

@Injectable({
  providedIn: 'root' 
})
export class UtilServiceProvider {
    constructor(private loading: LoadingService) {

    }
    private emailRejex: any = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    validateEmail(email: string): boolean {
        if (email) {
            return !!email.toLowerCase().match(this.emailRejex);
        }
        return false;
    }


    public blobToFile = (theBlob: Blob, fileName: string): File => {

        var b: any = theBlob;
        //A Blob() is almost a File() - it's just missing the two properties below which we will add
        b.lastModifiedDate = new Date();
        b.name = fileName;

        //Cast to a File() type
        return <File>theBlob;
    }
}